// extracted by mini-css-extract-plugin
module.exports = {"modal":"contact-module--modal--2ef30","content":"contact-module--content--2zl94","close":"contact-module--close--2msbL"};